import { map, prop } from 'ramda';
import { getRenamedAd } from '../utils/renameAd';

const Tag = data => {
  const ads = map(prop("content"), data.adv || {});

  const header_banner_panel = getRenamedAd(
    "header-banner",
    "header_banner_panel",
    ads
  );

  const lower_banner_panel = getRenamedAd(
    "show_ad_panel",
    "lower_banner_panel",
    ads
  );

  return ({
    ...data.story,
    content: {
      ...data.story.content,
      ads: {
        header_banner_panel,
        lower_banner_panel
      }
    }
  })
}

export { Tag }
